import React from 'react';

const StatsCard = ({ title, value, icon, color, subtext }) => {
    return (
        <div className="stats-card" style={{ borderLeft: `4px solid ${color}` }}>
            <div className="stats-icon" style={{ color: color, backgroundColor: `${color}20` }}>
                <i className={icon}></i>
            </div>
            <div className="stats-info">
                <span className="stats-title">{title}</span>
                <h3 className="stats-value" style={{ color: color }}>{value}</h3>
                {subtext && <span className="stats-subtext">{subtext}</span>}
            </div>
        </div>
    );
};

export default StatsCard;
